import React, {useContext, useEffect} from 'react';
import {ResponseVehicle} from '../../../types/api';
import {styled} from '@volkswagen-onehub/components-core';
import {VisualContext} from '../../../context/modules/dimensions/VisualContext';
import Visual from './Visual';
import Skeleton from 'react-loading-skeleton';

const VisualsContainer = styled.div`
`;

export default ({vehicles}: {vehicles: ResponseVehicle[]}) => {
  const {set} = useContext(VisualContext)!;

  useEffect(() => {
    if (!vehicles.length) return;

    set(vehicles[0]);
  }, [vehicles]);

  return vehicles.length ? (
    <VisualsContainer>
      <Visual vehicles={vehicles} />
    </VisualsContainer>
  ) : (
    <Skeleton
      width="100%"
      height="30vw"
      style={{display: 'block', marginBottom: '20px'}}
      inline
    />
  );
};
